// Utility for repeated async scheduling using timeouts
export function createTaskIntervalScheduler(runTask, onError) {
    return new TaskIntervalSchedulerImpl(runTask, onError);
}
class TaskIntervalSchedulerImpl {
    runTask;
    onError;
    scheduleTimeoutId;
    taskCompletionPromise = undefined;
    constructor(runTask, onError) {
        this.runTask = runTask;
        this.onError = onError;
    }
    start(interval) {
        if (this.scheduleTimeoutId) {
            return; // Already scheduled
        }
        const doTaskAndScheduleNext = () => {
            this.taskCompletionPromise = this.runTask()
                .catch(this.onError)
                .finally(() => {
                this.taskCompletionPromise = undefined;
                if (this.scheduleTimeoutId) {
                    this.scheduleTimeoutId = setTimeout(doTaskAndScheduleNext, interval);
                }
            });
        };
        this.scheduleTimeoutId = setTimeout(doTaskAndScheduleNext, interval);
    }
    async stop() {
        if (this.scheduleTimeoutId) {
            clearTimeout(this.scheduleTimeoutId);
            this.scheduleTimeoutId = undefined;
        }
        if (this.taskCompletionPromise) {
            await this.taskCompletionPromise; // Wait for the current task to finish
        }
    }
}
